
import { defineComponent, PropType } from 'vue';
import FieldAccessIcon from '@/lib/components/Fields/FieldAccessIcon.vue';
import { fieldLabelController, View } from '@/lib/components/Fields/FieldLabel.controller';
import { useController } from '@/domain/services/Composer';
import { Field } from '@/domain/models/Field';
import { Popover } from 'vue-bootstrap';

export default defineComponent({
	name: 'FieldLabel',
	inject: ['lang'],
	components: {
		Popover,
		FieldAccessIcon,
	},
	props: {
		field: {
			type: Object as PropType<Field>,
			required: true,
		},
		isManager: {
			type: Boolean,
			default: false,
		},
		for: {
			type: String,
			default: null,
		},
		elementId: {
			type: String,
			default: '',
		},
	},
	setup: useController(fieldLabelController, 'fieldLabelController') as () => View,
});
